<script>
import CustomersCrudListVue from 'App/customers/CustomersCrudList.vue';
import DataTableCpfCnpjColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';

export default {
  name: 'CommunicationClientList',
  extends: CustomersCrudListVue,
  props: {
    value: {
      type: Array,
      required: true,
    },
    select: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hideEdit: true,
      hideDelete: true,
      allowSelectAll: true,
      headers: [
        {
          text: this.$t('app.customers.list.headers.clienteIdSgv'),
          value: 'clienteIdSgv',
          align: 'right',
          orderBy: 'informacaoTendencia.tendenciaClienteId',
        },
        {
          text: this.$t('app.customers.list.headers.companyName'),
          value: 'nomeFantasia',
        },
        {
          text: this.$t('app.customers.list.headers.empresa'),
          value: 'nomeEmpresa',
        },
        {
          text: this.$t('app.customers.list.headers.document'),
          value: 'cpfCnpj',
          component: DataTableCpfCnpjColumnVue,
        },
      ],
    };
  },
  computed: {
    selectedCustomers: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isSelect() {
      return this.select;
    },
  },
  watch: {
    isSelect: {
      immediate: true,
      handler(bool) {
        if (typeof bool === 'boolean') {
          this.allowSelectAll = bool;
        }
      },
    },
  },
  created() {
    this.removeAllSelected();
    this.onRemoveSelectedItem();
  },
  methods: {
    rowUpdated(row = {}) {
      const alreadySelected = this.selectedCustomers.findIndex(
        item => item.id === row.id,
      );
      const override = this.selectedCustomers;

      if (alreadySelected < 0 && row.value) {
        const item = this.rows.find(
          r => r.id === row.id,
        );
        override.push({
          id: row.id,
          nomeFantasia: item.nomeFantasia,
        });
      } else if (alreadySelected >= 0 && !row.value) {
        override.splice(
          alreadySelected,
          1,
        );
      }

      this.selectedCustomers = override;
    },
    updatedSelectedRows(rows = []) {
      const customers = rows.reduce(
        (arr, { id, value }) => {
          const alreadyIds = this.selectedCustomers.map(
            item => item.id,
          );
          const row = this.rows.find(
            r => r.id === id,
          );

          if (!!value && !alreadyIds.includes(id)) {
            arr.push({
              id,
              nomeFantasia: row.nomeFantasia,
            });
          }
          return arr;
        },
        [],
      );

      this.selectedCustomers = [
        ...this.selectedCustomers,
        ...customers,
      ];
    },
    removeAllSelected() {
      this.$root.$on(
        'communication-client-remove-all-selected',
        (remove) => {
          if (remove) {
            this.selectedAllRows = this.selectedAllRows.reduce(
              (arr, row) => {
                const ids = this.selectedCustomers.map(
                  item => item.id,
                );

                arr.push({
                  id: row.id,
                  value: ids.includes(row.id) ? false : row.value,
                });

                return arr;
              },
              [],
            );
            this.selectedCustomers = [];
          }
        },
      );
    },
    onRemoveSelectedItem() {
      this.$root.$on(
        'communication-client-remove-item-selected',
        this.removeSelectedItem,
      );
    },
    removeSelectedItem(customer) {
      if (customer) {
        const rowIndex = this.selectedAllRows.findIndex(
          row => row.id === customer.id,
        );

        if (rowIndex > -1) {
          this.selectedAllRows.splice(rowIndex, 1, {
            value: false,
            id: customer.id,
          });
        }
      }
    },
  },
};
</script>
